/**
 * Functions for localizing text. A few sample use cases:

  // text.tsx

  export const text = {
    APP_H1: {
      no: 'Start pensjonsutbetaling',
      en: 'Start pension payment',
    },
    HELLO_WORLD_TEXT: {
      no: <>
        <p>Hei verden.</p>
        <p>Hvordan går det?</p>
      </>,
      en: <>
        <p>Hello world!</p>
        <p>How are you?</p>
      </>,
    },
    GREETING_FUNC: {
      no: (name) => `Hei ${name}!`
      en: (name) => `Hello ${name}!`
    }
    GREETING_COMP: {
      no: ({ name }) => <p>Hei {name}!</p>
      en: ({ name }) => <p>Hello {name}!</p>
    }
  };


  // usage.tsx

  <h1>{localized(text.APP_H1)}</h1>

  <div>{localized(text.HELLO_WORLD_TEXT)}</div>

  <p>{localized(text.GREETING_FUNC)(user.name)}</p>

  const Greeting = localized(text.GREETING_COMP);
  <Greeting name={user.name} />

 */
export function localized(data, locale) {
    if (!locale)
        locale = getLocale();
    if (locale === 'no_NB') {
        return data.no;
    }
    else {
        return data.en;
    }
}
export function toggleLocale() {
    setLocale(getLocale() === 'en_GB' ? 'no_NB' : 'en_GB');
}
export function setLocale(locale) {
    try {
        window.localStorage && window.localStorage.setItem('NG_TRANSLATE_LANG_KEY', locale);
    }
    catch (e) {
        console.warn('Unable to save locale setting:', e);
    }
}
export function reloadWithNewLocale(locale) {
    locale ? setLocale(locale) : toggleLocale();
    // reload window on locale change to make locale functions behave as otherwise pure
    window.location.reload();
}
export function getLocale() {
    try {
        var storedLocale = window.localStorage && window.localStorage.getItem('NG_TRANSLATE_LANG_KEY');
        if (storedLocale === 'en_GB')
            return 'en_GB';
    }
    catch (e) {
        console.warn('Unable to load locale setting. Falling back to "no_NB"');
    }
    return 'no_NB';
}
